var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpload01 = function SvgUpload01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12 2.5 5.3 5.3-1.133 1.139-3.371-3.364v11.33h-1.592V5.576L7.833 8.94 6.7 7.8zm-7.519 19q-.816 0-1.399-.582a1.9 1.9 0 0 1-.582-1.4v-3.79h1.592v3.79q0 .147.121.269.121.12.268.121H19.52q.146 0 .268-.121a.37.37 0 0 0 .121-.268v-3.79H21.5v3.79q0 .816-.582 1.399a1.9 1.9 0 0 1-1.4.582z"
  })));
};
export default SvgUpload01;